const faqItems = [
  {
    q: '暗网吃瓜上的爆料内容都是真实的吗？',
    a: '暗网吃瓜平台上的爆料内容来源多样，包括网友匿名投稿、编辑团队收集整理以及公开渠道信息汇总。我们会标注信息来源和可信度等级，但作为吃瓜平台，建议读者保持理性判断，自行甄别信息真伪。所有内容仅供娱乐参考，不构成事实认定。',
  },
  {
    q: '如何在暗网吃瓜投稿爆料？',
    a: '我们提供完全匿名的投稿渠道。你可以通过页面的"投稿爆料"版块提交你的爆料内容，系统不会记录任何个人信息。编辑团队审核通过后，内容将发布在吃瓜速递或热门爆料板块。我们承诺严格保护爆料人隐私，绝不透露任何投稿者信息。',
  },
  {
    q: '暗网吃瓜的更新频率是怎样的？',
    a: '我们的编辑团队 7×24 小时轮值，确保全天候内容更新。吃瓜速递板块每 15-30 分钟更新一次，热门爆料每日更新 10-20 条深度内容，焦点深扒每周推出 3-5 篇专题报道。关注我们不错过任何一个瓜！',
  },
  {
    q: '如果我发现平台上有不实信息怎么办？',
    a: '我们非常重视内容的真实性和准确性。如果你发现任何不实信息或侵权内容，请通过"投稿爆料"版块提交申诉，说明具体问题和事实依据。我们的编辑团队会在 24 小时内核实处理，确认为不实信息的内容将被立即下架并在原位置发布更正说明。',
  },
];

export function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">吃瓜问答</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">关于暗网吃瓜的常见问题与解答</p>
        <div className="mt-10 space-y-4">
          {faqItems.map((item, i) => (
            <div key={i} className="rounded-lg border border-background-200/50 bg-background-100 overflow-hidden">
              <div className="p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-500/15 text-primary-400 flex items-center justify-center text-xs font-medium mt-0.5">Q</span>
                  {item.q}
                </h3>
                <div className="mt-3 flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent-500/15 text-accent-400 flex items-center justify-center text-xs font-medium mt-0.5">A</span>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '匿名安全',
    desc: '所有爆料投稿完全匿名，采用端到端加密技术保护投稿人隐私，绝不泄露任何身份信息。你的安全，我们守护。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7×24 小时全天候内容更新，编辑团队实时监控全网热点，确保每一条今日黑料和新爆料都能第一时间送达。',
  },
  {
    icon: 'ri-group-line',
    title: '瓜友社区',
    desc: '百万活跃瓜友组成的吃瓜社区，随时随地畅聊最新爆料。加入爆料交流群，与志同道合的吃瓜群众一起嗨。',
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">平台优势</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">选择暗网吃瓜的三大理由</p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="p-6 rounded-lg border border-background-200/50 bg-background-50 hover:border-primary-500/20 transition-all text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-primary-500/10 flex items-center justify-center mx-auto">
                <i className={`${f.icon} text-2xl text-primary-400`}></i>
              </div>
              <h3 className="mt-4 text-base md:text-lg font-heading text-foreground-800">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

const mediaItems = [
  {
    title: '独家对话：娱乐圈资深爆料人讲述行业内幕',
    desc: '深度专访一位在娱乐圈从业二十年的资深人士',
    duration: '18:42',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20interview%20setting%20with%20silhouette%20figure%20in%20spotlight%2C%20mysterious%20atmosphere%2C%20red%20accent%20lighting%2C%20professional%20studio%20setup%2C%20dramatic%20cinematic%20look%2C%20dark%20background&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '实锤视频：某综艺现场导演指挥全过程',
    desc: '独家获取某综艺节目录制现场的幕后视频片段',
    duration: '05:31',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20behind%20the%20scenes%20film%20set%20with%20cameras%20and%20equipment%2C%20mysterious%20silhouettes%2C%20red%20lighting%2C%20documentary%20style%2C%20cinematic%20atmosphere&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '音频曝光：圈内大佬酒局私密对话记录',
    desc: '一段长达12分钟的私密对话音频配文字记录',
    duration: '12:08',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20private%20dining%20scene%20with%20audio%20waveform%20visualization%20overlay%2C%20mysterious%20gathering%2C%20red%20accent%20lighting%2C%20secret%20recording%20vibe%2C%20noir%20cinematography&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '深度分析：饭圈集资产业链背后的灰色地带',
    desc: '数据可视化分析饭圈集资的完整利益链条',
    duration: '09:15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20data%20visualization%20room%20with%20charts%20and%20graphs%20on%20screens%2C%20mysterious%20research%20atmosphere%2C%20red%20accent%20lighting%2C%20investigative%20style%2C%20cinematic&width=640&height=360&seq=media-04&orientation=landscape',
  },
];

export function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">爆料现场</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">独家视频与音频取证，还原事件真实面貌</p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-lg overflow-hidden border border-background-200/50 bg-background-100 hover:border-primary-500/20 transition-all">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded text-xs bg-background-50/90 text-foreground-700 font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">投稿爆料</h2>
        <p className="mt-2 text-sm text-foreground-500">你有猛料？匿名投稿，安全无忧，让你的声音被听见</p>
        <div className="mt-8 p-6 md:p-10 rounded-lg border border-primary-500/20 bg-background-50">
          <div className="flex flex-col items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-primary-500/10 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-400"></i>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              我们提供完全匿名的投稿渠道，系统不会记录任何个人信息。
              编辑团队审核通过后，你的爆料将在吃瓜速递或热门爆料板块发布。
              如有图片、音频、视频等证据，一并提交效果更好。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 mt-2">
              <span className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md font-medium text-sm whitespace-nowrap transition-colors cursor-pointer">
                <i className="ri-mail-line"></i> 匿名投稿
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-3 border border-background-300 hover:border-primary-500/50 text-foreground-600 hover:text-primary-400 rounded-md font-medium text-sm whitespace-nowrap transition-all cursor-pointer">
                <i className="ri-group-line"></i> 加入爆料交流群
              </span>
            </div>
            <p className="text-xs text-foreground-400 mt-2">投稿即表示同意暗网吃瓜的内容发布规则和隐私政策</p>
          </div>
        </div>
      </div>
    </section>
  );
}

const rankingItems = [
  { rank: 1, title: '某顶流男星深夜发文疑似回应恋情传闻', heat: '12.6万', change: 'up' },
  { rank: 2, title: '网红主播被曝数据造假，后台截图流出引热议', heat: '9.8万', change: 'up' },
  { rank: 3, title: '饭圈大粉卷款跑路，涉案金额超千万', heat: '8.4万', change: 'up' },
  { rank: 4, title: '某女星离婚内幕曝光，财产分割细节惊人', heat: '7.1万', change: 'down' },
  { rank: 5, title: '综艺导师被曝收取选手好处费引众怒', heat: '5.9万', change: 'up' },
];

export function RankingSection() {
  const rankColors = ['text-accent-400', 'text-accent-400', 'text-accent-400', 'text-foreground-500', 'text-foreground-500'];

  return (
    <section id="ranking" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center">热度榜单</h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">实时更新全网最热吃瓜话题排行</p>
        <div className="mt-10 space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-lg border border-background-200/50 bg-background-100 hover:border-primary-500/20 transition-all"
            >
              <span className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-heading font-bold ${i < 3 ? 'bg-accent-500/15 ' + rankColors[i] : 'bg-background-200 text-foreground-400'}`}>
                {item.rank}
              </span>
              <p className="flex-1 text-sm text-foreground-700 font-medium truncate">{item.title}</p>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-400">{item.heat}</span>
                <i className={`text-xs ${item.change === 'up' ? 'text-primary-400 ri-arrow-up-line' : 'text-foreground-400 ri-arrow-down-line'}`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}